// src/components/About.jsx
import React from 'react';
import '../css/About.css';

const About = () => {
  return (
    <section className="about" id="about">
      <div className="about-container">
        <h2 className="section-title">About Us</h2>
        <p className="highlight">🚀 Approved Technology Voucher Programme (TVP) Provider</p>
        <p className="about-description">
          GLOBAL TP TECHNOLOGY LIMITED is a Hong Kong-based tech company with deep experience in delivering <strong>e-commerce applications</strong>,
          <strong> custom web platforms</strong>, and <strong>POS solutions</strong> for businesses of all sizes.
        </p>
        <p className="about-description">
          We thrive on innovation and are actively exploring new opportunities in <strong>AI</strong> and <strong>Web3</strong> to deliver future-ready solutions.
        </p>
        <p className="callout">Let’s build something amazing together.</p>
      </div>
    </section>
  );
};

export default About;
